/**
 * Environment-based logger
 * - Logs appear in development mode
 * - Logs are hidden in production mode
 * - Errors always show (important for debugging production issues)
 */

const isDev = import.meta.env.MODE === 'development';

export const logger = {
  /**
   * Log general information (only in development)
   */
  log: (...args) => {
    if (isDev) console.log(...args);
  },

  /**
   * Log errors (always shown, even in production)
   */
  error: (...args) => {
    console.error(...args);
  },

  /**
   * Log warnings (only in development)
   */
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },

  /**
   * Log info (only in development)
   */
  info: (...args) => {
    if (isDev) console.info(...args);
  },

  /**
   * Log debug information (only in development)
   */
  debug: (...args) => {
    if (isDev) console.debug(...args);
  }
};
